import React from 'react';
import './DetailsPage.scss';
import { Icon, Card, Button } from '@design-system/index';
import { AppartementsLine } from '@assets/images/icons';
import { DetailsTabs } from './DetailsTabs';
import { Tabs } from '@components/Tabs/Tabs';
import { useNavigate, useParams } from 'react-router-dom';

export default function DetailsPage() {
    const navigate = useNavigate();
    const { id, tab } = useParams();
    const tabIndex = DetailsTabs().findIndex((t) => t.path === tab);

    return (
        <div className="details-apartment-container">
            <Card
                headerType="full"
                showBack
                backTo="/members-management/apartments"
                headerTitle="Fiche logement"
                headerIcon={<Icon icon={<AppartementsLine />} size={20} color="primary" />}
                topActions={
                    <Button variant="primary" color="primary" onClick={() => navigate(`/members-management/apartments/${id}/bookings/add`)}>
                        Créer une réservation
                    </Button>
                }
            >
                <Tabs orientation="horizontal" tabs={DetailsTabs} defaultActiveTab={tabIndex === -1 ? 0 : tabIndex} />
            </Card>
        </div>
    );
}
